import React from 'react';
import { ResponsiveContainer, PieChart, Pie, Cell, Tooltip } from 'recharts';
import './Dashboard.css';

export default function GlobalDistributionDonut({ data }) {
  const { total, distribution } = data;

  // Centralized palette (cycles if there are more slices than colors)
  const palette = [
    'var(--c1)', 'var(--c2)', 'var(--c3)', 'var(--c4)', 'var(--c5)',
    'var(--c6)', 'var(--c7)', 'var(--c8)', 'var(--c9)', 'var(--c10)'
  ];
  

  const CenterLabel = () => (
    <>
      <text x="50%" y="46%" textAnchor="middle" className="gd-total">{total}</text>
      <text x="50%" y="60%" textAnchor="middle" className="gd-sub">Devices</text>
    </>
  );

  return (
    <div className="gd-card">
      <h2 className="gd-title">GLOBAL DISTRIBUTION OF ILT</h2>

      <div className="gd-wrap">
        <div className="gd-chart">
          <ResponsiveContainer width="100%" height="100%">
            <PieChart>
              <Pie
                data={distribution}
                cx="50%"
                cy="50%"
                innerRadius="45%"
                outerRadius="85%"
                startAngle={90}
                endAngle={-270}
                paddingAngle={1.5}
                dataKey="valuex"
              >
                {distribution.map((e, i) => (
                  <Cell key={i} fill={palette[i % palette.length]} />
                ))}
              </Pie>
              <CenterLabel />
              <Tooltip
                formatter={(val) => `${val.toLocaleString('en-US')} Devices`}
                labelFormatter={(name) => name}
              />
            </PieChart>
          </ResponsiveContainer>
        </div>

        <div className="gd-legend">
          {distribution.map((d, i) => (
            <div key={i} className="gd-legend-row">
              <span className="dot" style={{ background: palette[i % palette.length] }} />
              <span className="name">{d.name}</span>
              <span className="pct">{d.value.toFixed(1)}%</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
